exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".form-adhoc-backup .description-block {\n  padding-bottom: 20px; }\n\n.form-adhoc-backup .form-block {\n  margin-top: 0px; }\n\n.form-adhoc-backup .form-action {\n  float: right; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/dataprotection/dataprotection-vc/adhoc-backup/adhoc-backup.scss
// module id = F4MK
// module chunks = 0